<template>
  <div class="Header">
    <div class="header_nav">
      <router-link v-for="(item,index) in navNow" :key="index" :class="{checked:index===now}" :to="item.route!=null?{name:item.route}:''" tag="a"><span>{{item.title}}</span></router-link>
    </div>
    <div class="userbox">
      <div>
        <img :src="userInfo.avatar"/>
<!--        <&#45;&#45;图片地址动态绑定&ndash;&gt;-->
        <span>安平县路灯所</span>
        <a class="msg" :href="'http://'+'27.128.181.220:9998/management/News'" ><span class="icon-msg"></span>
          <div v-if="this.tabledata!==0"><a>{{this.tabledata}}</a></div>
        </a>
        <button title="退出" @click="out"><span class="icon-out"></span>退出</button>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    computed:{
      user(){
        return this.$store.state.user
      }
    },
    name: "Header",
    props: ["now","showSingle"],
    methods: {
      setting(){
        //跳转到上次页面
        //this.$router.go(-1)
        //跳转到指定页面
        //this.$router.replace{'/setting'}
        //跳转到指定路由的名字下
        // this.$router.replace({name:'setting'})
        //通过push跳转
        // this.$router.push('/setting')
        // this.$router.push({name:'setting'})
      },
      out(){
        this.$router.push({path: '/'})
      }
    },
    mounted() {
      if(this.showSingle){
        this.navNow = [
          {
            title: "远程监控",
            route: "monitoring"
          }
        ]
      }else{
        this.navNow = [
          {
            title: "首页",
            route: "home"
          },
          {
            title: "GIS信息",
            route: "geographic_information"
          },
          {
            title: "远程监控",
            route: "monitoring"
          },
          // {
          //   title: "项目管理",
          //   route: "project_manage"
          // },
          {
            title: "运维管理",
            route: "management"
          },
          // {
          //   title: "资产管理",
          //   route: "AssetsManagement"
          // },
          {
            title: "系统管理",
            route: "Setting"
          },

        ];
      }
      //获取消息列表
        fetch("/api/v1/message/list", {
          method: 'post',
          body: JSON.stringify({
            "page_start": 0,
            "page_size": 10,
            "project_id": "17e3b71e-b460-498e-b0ef-657d20bd6549",
            "is_read": ""
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "消息列表获取成功";
              this.tabledata = data.unread_number;
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });

    },
    data() {
      return {
        userInfo: {
          avatar: 'https://gss0.bdstatic.com/-4o3dSag_xI4khGkpoWK1HF6hhy/baike/c0%3Dbaike92%2C5%2C5%2C92%2C30/sign=62d46c39067b020818c437b303b099b6/d4628535e5dde7119c3d076aabefce1b9c1661ba.jpg'
        },
        tabledata:'',
        navNow: [],
      }
    },
    // created() {
    //   this.$http.get("http://124.239.196.155/db_zdcloud_base/zd_user")
    //     .then((data) =>{
    //       console.log(data)
    //   })
    // }
  }
</script>

<style scoped>
  .Header {
    margin-left: 270px;
    width: calc(100% - 270px);
    height: 78px;
    background: -webkit-linear-gradient(left, #1d4e80, #0c365f); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(right, #1d4e80, #0c365f); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(right, #1d4e80, #0c365f); /* Firefox 3.6 - 15 */
    background: linear-gradient(to right, #1d4e80, #0c365f); /* 标准的语法 */
  }

  .header_nav {
    width: auto;
    display: flex;
    align-items: center;
    float: left;
    height: 78px;
  }

  .header_nav a {
    width: auto;
    padding: 0 25px;
    line-height: 78px;
    height: 78px;
    text-align: center;
    position: relative;
    left: 65px;
  }

  .header_nav a span {
    background-image: -webkit-linear-gradient(bottom, #169cff, #2bffff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 20px;
    font-weight: bold;
    /*-webkit-text-stroke-width: 1px;*/
    /*-webkit-text-stroke-color: #073e76;*/
  }

  .header_nav .checked {
    background: #02386c;
  }

  .header_nav .checked:before {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    height: 2px;
    background: #00f0ff;

    content: '';
    z-index: 10;
  }

  .header_nav .checked span {
    -webkit-text-stroke-width: 0px;
    background-image: -webkit-linear-gradient(bottom, #ffffff, #ffffff);
  }

  .userbox {
    height: 78px;
    width: auto;
    float: right
  }

  .userbox div {
    width: auto;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .userbox div img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-right: 8px
  }

  .userbox > div > span {
    color: #95bee5;
    margin-right: 20px
  }

  .userbox .msg {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-right: 20px;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .userbox .msg span {
    font-size: 20px;
    color: #ffffff
  }

  .userbox .msg div {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    position: absolute;
    top: -6px;
    right: -6px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ff0000;
  }

  .userbox .msg div a {
    color: #ffffff;
    font-size: 10px;
    -webkit-transform: scale(0.8);
  }

  .userbox button {
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    outline: none;
    background: transparent;
    margin-right: 20px;
    font-size: 16px;
    height: 22px;
    line-height: 22px;
    color: #95bee5;
    cursor: pointer;
  }
  .userbox button span{margin-right: 4px}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue